import css from "classnames";
import * as React from "react";
import { SportEvent } from "./model";

const styles = require("./styles.scss"); // tslint:disable-line no-var-requires

interface Props {
    sportEvent: SportEvent;
}

function TennisPreLive({ sportEvent }: Props): JSX.Element | null {
    if (!sportEvent) {
        return null;
    }

    const { event } = sportEvent;
    const live =
        event.type && event.type === "live" ? (
            <span className={styles.live}>LIVE</span>
        ) : null;

    return (
        <section className={css(styles.scorecenter)}>
            <div className={styles.dataTime}>
                <span>{event.dateAndTime}</span>
                {live}
            </div>
            <div className={styles.teams}>
                <div>{event.team1}</div>
                <div>{event.team2}</div>
            </div>
        </section>
    );
}
export default TennisPreLive;
